// © Microsoft Corporation. All rights reserved.

import { DOM } from "@microsoft/fast-element";

/**
 * Manually runs a Shadow DOM update for FAST web components.
 */
export function runShadowDomUpdate(): Promise<void> {
    return new Promise<void>(resolve => DOM.queueUpdate(() => resolve()));
}